import { NodeType } from '@journeys/Enums';

export const staticPresetsStart = (): any => {
    return {
        List: {
            id: 25,
            x: 0,
            y: 0,
            h: 70,
            w: 70,
            i: 17,
            ic: 109,
            f: 2,
            fc: 168,
            data: {
                title: $Resources.JourneyNodeList,
                name: 'List',
                description: '',
                type: 1,
                var: 1,
                delay_d: 0,
                conditions: [],
                segments: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
                ListId: null,
                ListIds: [],
                SegmentIds: [],
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
    };
};

export const staticPresetsActions = (): any => {
    return {
        Email: {
            id: 22,
            x: 0,
            y: 0,
            h: 70,
            w: 70,
            i: 20,
            ic: 109,
            f: 2,
            fc: 60,
            lnto: {},
            lnfr: {},
            data: {
                title: $Resources.JourneyNodeEmail,
                name: 'Email',
                description: '',
                type: 2,
                var: 1,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
            },
            runtime: {
                cache: {},
            },
        },
        Sms: {
            id: 22,
            x: 0,
            y: 0,
            h: 70,
            w: 70,
            i: 2,
            ic: 109,
            f: 2,
            fc: 60,
            lnto: {},
            lnfr: {},
            data: {
                title: $Resources.JourneyNodeSms,
                name: 'Sms',
                description: '',
                type: 2,
                var: 4,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
            },
            runtime: {
                cache: {},
            },
        },
        Tag: {
            id: 22,
            x: 0,
            y: 0,
            h: 70,
            w: 70,
            i: 42,
            ic: 109,
            f: 2,
            fc: 60,
            lnto: {},
            lnfr: {},
            data: {
                title: $Resources.JourneyNodeTag,
                name: 'Tag',
                description: '',
                type: 2,
                var: 5,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
                TagIdsToAdd: [],
                TagIdsToRemove: [],
            },
            runtime: {
                cache: {},
            },
        },
        ContactList: {
            id: 22,
            x: 0,
            y: 0,
            h: 70,
            w: 70,
            i: 17,
            ic: 109,
            f: 2,
            fc: 60,
            lnto: {},
            lnfr: {},
            data: {
                title: $Resources.JourneyNodeContactList,
                name: 'ContactList',
                description: '',
                type: 2,
                var: 6,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
                ListIdToAdd: null,
                ListIdToRemove: null,
            },
            runtime: {
                cache: {},
            },
        },
        /*
    Event: {
        id: 26,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 19,
        ic: 91,
        f: 2,
        fc: 60,
        data: {
            title: 'Event',
            name: 'Event',
            description: '',
            type: 2,
            var: 2,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
            nx: -103,
            ny: -623,
        },
    },
    Survey: {
        id: 27,
        x: 0,
        y: 0,
        h: 70,
        w: 70,
        i: 1,
        ic: 91,
        f: 2,
        fc: 60,
        data: {
            title: 'Survey',
            name: 'Survey',
            description: '',
            type: 2,
            var: 3,
            delay_d: 0,
            conditions: [],
            segment: {
                Type: 'SegmentGroup',
                Bool: 1,
                Segments: [],
            },
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    */
    };
};

// TODO types like email segment event conditions
export const staticPresetsConditions = (): any => {
    return {
        Wait: {
            id: 22,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 28,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeWait,
                name: 'Wait',
                description: '',
                type: NodeType.Condition,
                var: 1,
                delay_d: 7,
                delay_h: 0,
                delay_m: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        Condition: {
            id: 24,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 18,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeCondition,
                name: 'Condition',
                description: '',
                type: NodeType.Condition,
                var: 2,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        EmailOpen: {
            id: 32,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 34,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeOpened,
                name: 'Opened',
                description: '',
                type: NodeType.Condition,
                var: 4,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: true,
                            Types: [4],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        EmailNotOpen: {
            id: 32,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 39,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeNotOpened,
                name: 'Not opened',
                description: '',
                type: NodeType.Condition,
                var: 4,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: false,
                            Types: [4],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        Clicked: {
            id: 33,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 36, // banned: 37
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeClicked,
                name: 'Clicked',
                description: '',
                type: NodeType.Condition,
                var: 6,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: true,
                            Types: [5],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        NotClicked: {
            id: 33,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 37,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeNotClicked,
                name: 'Not clicked',
                description: '',
                type: NodeType.Condition,
                var: 6,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: false,
                            Types: [5],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        EmailBounced: {
            id: 31,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 33,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeBounced,
                name: 'Bounced',
                description: '',
                type: NodeType.Condition,
                var: 3,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: true,
                            Types: [11],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        EmailUnsub: {
            id: 34,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 35,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeUnsubscribed,
                name: 'Unsubscribed',
                description: '',
                type: NodeType.Condition,
                var: 5,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: true,
                            Types: [9],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        AnsweredSurvey: {
            id: 33,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 40,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeAnswered,
                name: 'Answered',
                description: '',
                type: NodeType.Condition,
                var: 6,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: false,
                            Types: [5],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        NotAnsweredSurvey: {
            id: 33,
            x: 0,
            y: 0,
            h: 36,
            w: 36,
            i: 41,
            ic: 109,
            f: 2,
            fc: 216,
            data: {
                title: $Resources.JourneyNodeDidNotAnswer,
                name: 'Did not answer',
                description: '',
                type: NodeType.Condition,
                var: 6,
                delay_d: 0,
                conditions: [],
                segment: {
                    Type: 'SegmentGroup',
                    Bool: 1,
                    Segments: [
                        {
                            Type: 'InteractionSegment',
                            Name: null,
                            ObjectId: null,
                            HasInteractions: false,
                            Types: [5],
                        },
                    ],
                },
            },
            lnto: {},
            lnfr: {},
            runtime: {
                cache: {},
            },
        },
        // TODO add back when icons are in place
        // EventRegistered: {
        //     id: 34,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 42,
        //     ic: 109,
        //     f: 2,
        //     fc: 216,
        //     data: {
        //         title: 'Event Registered',
        //         name: 'Event Registered',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventRegistered,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Registered],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventInvited: {
        //     id: 35,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 43,
        //     ic: 110,
        //     f: 2,
        //     fc: 217,
        //     data: {
        //         title: 'Event Invited',
        //         name: 'Event Invited',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventInvited,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Invited],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventWaitlist: {
        //     id: 36,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 44,
        //     ic: 111,
        //     f: 2,
        //     fc: 218,
        //     data: {
        //         title: 'Event Waitlist',
        //         name: 'Event Waitlist',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventWaitlist,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Waitlist],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventAccepted: {
        //     id: 37,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 45,
        //     ic: 112,
        //     f: 2,
        //     fc: 219,
        //     data: {
        //         title: 'Event Accepted',
        //         name: 'Event Accepted',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventAccepted,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Accepted],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventDeclined: {
        //     id: 38,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 46,
        //     ic: 113,
        //     f: 2,
        //     fc: 220,
        //     data: {
        //         title: 'Event Declined',
        //         name: 'Event Declined',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventDeclined,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Declined],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventCancelled: {
        //     id: 39,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 47,
        //     ic: 114,
        //     f: 2,
        //     fc: 221,
        //     data: {
        //         title: 'Event Cancelled',
        //         name: 'Event Cancelled',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventCancelled,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Cancelled],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventAttended: {
        //     id: 40,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 48,
        //     ic: 115,
        //     f: 2,
        //     fc: 222,
        //     data: {
        //         title: 'Event Attended',
        //         name: 'Event Attended',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventAttended,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.Attended],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
        // EventNoShow: {
        //     id: 41,
        //     x: 0,
        //     y: 0,
        //     h: 36,
        //     w: 36,
        //     i: 49,
        //     ic: 116,
        //     f: 2,
        //     fc: 223,
        //     data: {
        //         title: 'Event NoShow',
        //         name: 'Event NoShow',
        //         description: '',
        //         type: NodeType.Condition,
        //         var: NodeConditionVariation.EventNoShow,
        //         delay_d: 0,
        //         conditions: [],
        //         segment: {
        //             Type: 'SegmentGroup',
        //             Bool: 1,
        //             Segments: [
        //                 {
        //                     Type: 'EventParticipantStatusSegment',
        //                     Name: null,
        //                     EventId: null,
        //                     HasStatus: true,
        //                     Statuses: [EventParticipantStatus.NoShow],
        //                 },
        //             ],
        //         },
        //     },
        //     lnto: {},
        //     lnfr: {},
        //     runtime: {
        //         cache: {},
        //     },
        // },
    };
};

/*
export const staticPresetsPages: any = {
    PageGeneric: {
        id: 27,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 29,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Generic Page',
            name: 'Generic Page',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    PageImport: {
        id: 28,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 30,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Import',
            name: 'Import',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    PageOptIn: {
        id: 29,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 31,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Opt in',
            name: 'Opt in',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
    PageSurvey: {
        id: 30,
        x: 0,
        y: 0,
        h: 156,
        w: 120,
        i: 32,
        ic: 0,
        f: 0,
        fc: 0,
        data: {
            title: 'Survey',
            name: 'Survey',
            description: '',
            type: 5,
            var: 1,
        },
        lnto: {},
        lnfr: {},
        runtime: {
            cache: {},
        },
    },
};
*/
